import React, { useEffect } from 'react';
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import AuthFlowManager from "./AuthFlowManager";
import { useLocation } from 'react-router-dom';

const FormConfirm: React.FC = React.memo(() => {
    const location = useLocation();

    // Get code and email from URL params
    const getQueryParam = (param: string): string | null => {
        return new URLSearchParams(location.search).get(param);
    };

    const urlCode = getQueryParam('code');
    const urlEmail = getQueryParam('email');

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
                width: '100%',
                flex: 1,
                minHeight: 0 // Allows flex children to shrink below content size
            }}
        >
            {/* Header - Pinned at top */}
            <Box
                sx={{
                    flexShrink: 0,
                    pb: 2
                }}
            >
                <Typography variant="h4" component="h1" gutterBottom align="center">
                    Confirm Email
                </Typography>
            </Box>

            {/* Form content - Scrollable area with spacing from header */}
            <Box
                sx={{
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    minHeight: 0,
                    overflowY: 'auto',
                    pt: 2,
                    pb: 4
                }}
            >
                <AuthFlowManager
                    flowType="confirm"
                    onStepTransition={(step, error, data) => {
                        // Handle step transitions for confirm flow
                    }}
                    initialStepConfig={{
                        verifyEmail: 'enabled',
                        login: 'hidden',
                        setupMFA: 'hidden',
                        verifyMFA: 'hidden'
                    }}
                    urlCode={urlCode}
                    urlEmail={urlEmail}
                />
            </Box>

        </Box>
    );
});

FormConfirm.displayName = 'FormConfirm';

export default FormConfirm;
